import React from 'react';
import { Link } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';

import { AnalyticsPage } from '../components/page/analytics-page';
import { DASHBOARD, REPORT } from '../constants';
import { REPORTS, REPORTS_KEYS, REPORTS_LINKS } from './constants';
import { pageMessages, labelsMessages, linksMessages, messages } from './messages';
import style from './style.module.less';
import { useEnableBillingReport } from '../../../feature-flags/hooks/enable-billing-report';
import analyticsStyle from '../analytics-style.module.less';

export const AnalyticsReportsPage = () => {
  const isBillingReportsEnabled = useEnableBillingReport();

  const filteredReportsKeys = REPORTS_KEYS.filter((section) => (section === 'fulfilledByShipStation' ? isBillingReportsEnabled : true));

  return (
    <AnalyticsPage pageTitle={pageMessages}>
      <div className={analyticsStyle['analytics-reports-page']}>
        {filteredReportsKeys.map((report) => (
          <div key={report} className={analyticsStyle['analytics-section-wrapper']}>
            <Text textType={TextType.H3} value={labelsMessages[report] ?? report} />
            <div className={style['section-details']}>
              {REPORTS[report].pages.map((page) => (
                <div key={page} className={analyticsStyle['analytics-section-detail']}>
                  <Link className={analyticsStyle['analytics-section-link']} to={`/${DASHBOARD}/${REPORT}/${REPORTS_LINKS[page]}`}>
                    <Text textType={TextType.H4} value={linksMessages[page]} />
                  </Link>
                  <Text textType={TextType.Caption} value={messages[page]} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </AnalyticsPage>
  );
};
